let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aOYI0")).then(() => parcelRequire('5MqEI'));